<div class="page">
  <header class="hero">
    <p class="eyebrow">ניהול קטלוג</p>
    <h1>תצוגת שם מוצר</h1>
    <p class="lede">
      הזינו ברקוד. הכותרת נבחרת אוטומטית: שופרסל, אחר כך רמי לוי, אחר כך הכללים.
      ערכו ידנית רק אם צריך לכוון. שלבי מחנות ושלבי הכללים מוצגים למטה לשקיפות.
    </p>
    <div class="tabs" role="tablist">
      <button
        type="button"
        role="tab"
        [class.active]="view === 'lookup'"
        data-testid="name-preview-tab-lookup"
        (click)="switchView('lookup')"
      >
        ברקוד
      </button>
      <button
        type="button"
        role="tab"
        [class.active]="view === 'size-mismatches'"
        data-testid="name-preview-tab-size-mismatches"
        (click)="switchView('size-mismatches')"
      >
        גודל שונה מהפיד
        <span class="tab-count" *ngIf="mismatchesTotal > 0">({{ mismatchesTotal }})</span>
      </button>
    </div>
  </header>

  <ng-container *ngIf="view === 'lookup'">
    <form class="lookup" (submit)="$event.preventDefault(); preview()">
      <label for="name-preview-barcode">ברקוד</label>
      <div class="lookup-row">
        <input
          id="name-preview-barcode"
          class="barcode-input"
          data-testid="name-preview-barcode"
          name="barcode"
          type="text"
          inputmode="numeric"
          dir="rtl"
          [(ngModel)]="barcode"
          placeholder="5411188112709"
          [disabled]="loading"
        />
        <button type="submit" data-testid="name-preview-submit" [disabled]="loading">
          הצג שלבים
        </button>
      </div>
    </form>

    <p class="error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
    <p class="ok" role="status" *ngIf="statusMessage">{{ statusMessage }}</p>
    <p class="muted" *ngIf="loading">טוען מקורות פיד…</p>

    <ng-container *ngIf="result as preview">
      <section class="curation" aria-label="כותרת בחנות">
        <h2>כותרת בחנות</h2>
        <p class="muted" *ngIf="preview.dbNameRaw">שם במסד (פיד): {{ preview.dbNameRaw }}</p>
        <p class="effective">
          <span class="badge" [attr.data-testid]="'name-preview-source'">{{ sourceLabel(preview.displayNameSource) }}</span>
          <strong data-testid="name-preview-effective-title" dir="auto">{{ preview.title }}</strong>
        </p>

        <div class="candidates">
          <article class="candidate" data-testid="name-preview-candidate-shufersal">
            <h3>שופרסל</h3>
            <p class="muted">{{ statusLabel(candidateFor('shufersal')?.status) }}</p>
            <p dir="auto">{{ candidateFor('shufersal')?.name || '—' }}</p>
            <p class="muted" dir="auto" *ngIf="candidateFor('shufersal')?.brandName">
              מותג: {{ candidateFor('shufersal')?.brandName }}
            </p>
            <p class="muted" dir="auto" *ngIf="candidateFor('shufersal')?.sizeText">
              גודל: {{ candidateFor('shufersal')?.sizeText }}
            </p>
            <p class="muted" dir="auto" *ngIf="candidateFor('shufersal')?.description">
              {{ candidateFor('shufersal')?.description }}
            </p>
            <button
              type="button"
              data-testid="name-preview-use-shufersal"
              [disabled]="saving || !candidateFor('shufersal')?.name || preview.productId == null"
              (click)="useCandidate('shufersal')"
            >
              העתיקו לעריכה
            </button>
          </article>
          <article class="candidate" data-testid="name-preview-candidate-rami">
            <h3>רמי לוי</h3>
            <p class="muted">{{ statusLabel(candidateFor('rami_levy')?.status) }}</p>
            <p dir="auto">{{ candidateFor('rami_levy')?.name || '—' }}</p>
            <p class="muted" dir="auto" *ngIf="candidateFor('rami_levy')?.brandName">
              מותג: {{ candidateFor('rami_levy')?.brandName }}
            </p>
            <p class="muted" dir="auto" *ngIf="candidateFor('rami_levy')?.sizeText">
              גודל: {{ candidateFor('rami_levy')?.sizeText }}
            </p>
            <button
              type="button"
              data-testid="name-preview-use-rami"
              [disabled]="saving || !candidateFor('rami_levy')?.name || preview.productId == null"
              (click)="useCandidate('rami_levy')"
            >
              העתיקו לעריכה
            </button>
          </article>
          <article class="candidate" data-testid="name-preview-candidate-rules">
            <h3>כללים</h3>
            <p class="muted">מולחן מהפיד</p>
            <p dir="auto">{{ preview.rulesTitle || preview.title }}</p>
            <button
              type="button"
              data-testid="name-preview-use-rules"
              [disabled]="saving || !(preview.rulesTitle || preview.title) || preview.productId == null"
              (click)="useCandidate('rules')"
            >
              העתיקו לעריכה
            </button>
          </article>
        </div>

        <form class="manual" (submit)="$event.preventDefault(); saveManual()">
          <label for="name-preview-manual">עריכה ידנית</label>
          <div class="lookup-row">
            <input
              id="name-preview-manual"
              data-testid="name-preview-manual"
              name="manualName"
              type="text"
              dir="auto"
              [(ngModel)]="manualDraft"
              [disabled]="saving || preview.productId == null"
            />
            <button
              type="submit"
              data-testid="name-preview-save-manual"
              [disabled]="saving || !manualDraft.trim() || preview.productId == null"
            >
              שמירה
            </button>
            <button
              type="button"
              class="secondary"
              data-testid="name-preview-clear-manual"
              [disabled]="saving || !preview.displayNameManual || preview.productId == null"
              (click)="clearManual()"
            >
              בטל ידני
            </button>
          </div>
        </form>

        <button
          type="button"
          class="secondary"
          data-testid="name-preview-fetch-missing"
          [disabled]="fetchingMissing || !preview.canFetchMissing"
          (click)="fetchMissing()"
        >
          {{ fetchingMissing ? 'מושך מהאתר…' : 'משוך שם חסר' }}
        </button>
      </section>

      <section class="sources" aria-label="מקורות פיד">
        <h2>מקורות</h2>
        <p class="muted" *ngIf="preview.dbNameRaw">שם במסד: {{ preview.dbNameRaw }}</p>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>רשת</th>
                <th>ItemName</th>
                <th>Quantity / UnitQty</th>
                <th>יצרן</th>
                <th>QtyInPackage</th>
                <th>סניף / קובץ</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let source of preview.sources; let i = index">
                <tr>
                  <td>{{ source.chainName }}</td>
                  <td dir="auto">{{ source.itemName }}</td>
                  <td dir="auto">{{ formatSize(source.quantity, source.unitQty) }}</td>
                  <td dir="auto">{{ source.manufactureName || '—' }}</td>
                  <td>{{ source.qtyInPackage ?? '—' }}</td>
                  <td class="file">
                    {{ source.storeId || '—' }}
                    <small *ngIf="source.sourceFile">{{ source.sourceFile }}</small>
                  </td>
                </tr>
                <tr *ngIf="source.xml" [attr.data-testid]="'name-preview-xml-' + i">
                  <td colspan="6">
                    <pre class="xml" dir="ltr">{{ source.xml }}</pre>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </section>

      <section class="sources" aria-label="רמת ביטחון" *ngIf="preview.attributes?.length">
        <h2>רמת ביטחון</h2>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>שדה</th>
                <th>ערך</th>
                <th>ביטחון</th>
                <th>מקור</th>
                <th>ראיה</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let attribute of preview.attributes" [attr.data-testid]="'name-preview-attr-' + attribute.name">
                <td>{{ attribute.name }}</td>
                <td dir="auto">{{ attribute.value || '—' }}</td>
                <td>{{ attribute.confidence | number:'1.0-2' }}</td>
                <td>{{ attribute.source }}</td>
                <td dir="auto">{{ attribute.evidence }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="steps-block" *ngIf="preview.storefrontSteps?.length" aria-label="שלבי כותרת מחנות">
        <h2>שלבי כותרת מחנות</h2>
        <ol class="steps">
          <li
            class="step-card"
            *ngFor="let step of preview.storefrontSteps"
            [attr.data-testid]="'name-preview-storefront-step-' + step.id"
          >
            <p class="step-label">{{ step.label }}</p>
            <p class="step-explain" *ngIf="step.note">{{ step.note }}</p>
            <dl>
              <div>
                <dt>קלט</dt>
                <dd dir="auto">{{ step.input }}</dd>
              </div>
              <div>
                <dt>פלט</dt>
                <dd dir="auto">{{ step.output }}</dd>
              </div>
            </dl>
          </li>
        </ol>
      </section>

      <section class="steps-block" aria-label="שלבי כללי פיד">
        <h2>שלבי כללי פיד</h2>
        <ol class="steps">
          <li class="step-card" *ngFor="let step of preview.steps" [attr.data-testid]="'name-preview-step-' + step.id">
            <p class="step-label">{{ step.label }}</p>
            <p class="step-explain" *ngIf="step.note">{{ step.note }}</p>
            <dl>
              <div>
                <dt>קלט</dt>
                <dd dir="auto">{{ step.input }}</dd>
              </div>
              <div>
                <dt>פלט</dt>
                <dd dir="auto">{{ step.output }}</dd>
              </div>
            </dl>
          </li>
        </ol>
      </section>

      <section class="final-card" aria-label="תוצאה סופית">
        <p class="final-kicker">כרטיס חיפוש</p>
        <h3 data-testid="name-preview-final-title" dir="auto">{{ preview.title }}</h3>
        <p
          class="product-result-meta"
          data-testid="name-preview-final-subtitle"
          dir="auto"
          *ngIf="preview.subtitle"
        >
          {{ preview.subtitle }}
        </p>
      </section>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="view === 'size-mismatches'">
    <section class="mismatches" aria-label="גודל בכותרת שונה מהפיד">
      <p class="lede">
        כותרות מחנות שבהן הגודל בכותרת שונה מהגודל המנורמל מהפיד.
        במקרים האלה הגודל נשאר בכותרת (לא מוסר לכותרת המשנה).
      </p>
      <div class="lookup-row mismatch-toolbar">
        <button
          type="button"
          class="secondary"
          data-testid="name-preview-mismatches-refresh"
          [disabled]="mismatchesLoading"
          (click)="loadMismatches(mismatchesOffset)"
        >
          {{ mismatchesLoading ? 'טוען…' : 'רענון' }}
        </button>
        <p class="muted" *ngIf="mismatchesTotal > 0">
          {{ mismatchesOffset + 1 }}–{{ mismatchesOffset + mismatches.length }} מתוך {{ mismatchesTotal }}
        </p>
      </div>

      <p class="error" role="alert" *ngIf="mismatchesError">{{ mismatchesError }}</p>
      <p class="muted" *ngIf="mismatchesLoading && mismatches.length === 0">טוען אי-התאמות…</p>
      <p class="muted" *ngIf="!mismatchesLoading && !mismatchesError && mismatches.length === 0">
        אין מוצרים עם גודל שונה מהפיד.
      </p>

      <div class="table-wrap" *ngIf="mismatches.length">
        <table data-testid="name-preview-mismatches-table">
          <thead>
            <tr>
              <th>ברקוד</th>
              <th>מקור</th>
              <th>כותרת בחנות</th>
              <th>גודל בכותרת</th>
              <th>גודל בפיד</th>
              <th>size_text</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of mismatches" [attr.data-testid]="'name-preview-mismatch-' + row.barcode">
              <td>
                <button
                  type="button"
                  class="linkish"
                  (click)="openMismatch(row)"
                >
                  {{ row.barcode }}
                </button>
              </td>
              <td>{{ sourceLabel(row.displayNameSource) }}</td>
              <td dir="auto">{{ row.title }}</td>
              <td dir="auto">{{ row.titleSize || '—' }}</td>
              <td dir="auto">{{ row.feedSize || '—' }}</td>
              <td dir="auto">{{ row.storefrontSizeText || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lookup-row mismatch-toolbar" *ngIf="mismatchesTotal > mismatchesPageSize">
        <button
          type="button"
          class="secondary"
          data-testid="name-preview-mismatches-prev"
          [disabled]="mismatchesLoading || !mismatchesHasPrev"
          (click)="loadMismatches(mismatchesPrevOffset())"
        >
          הקודם
        </button>
        <button
          type="button"
          class="secondary"
          data-testid="name-preview-mismatches-next"
          [disabled]="mismatchesLoading || !mismatchesHasNext"
          (click)="loadMismatches(mismatchesNextOffset())"
        >
          הבא
        </button>
      </div>
    </section>
  </ng-container>
</div>
